
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.735 0C14.456 0 15.992 1.543 16 4.264v7.472C16 14.456 14.456 16 11.735 16h-7.47C1.542 16 0 14.456 0 11.736V4.264C0 1.544 1.543 0 4.264 0h7.471zM8.4 3.304a.672.672 0 00-1.025.632v8.152c.041.344.328.6.664.6a.661.661 0 00.664-.6V3.936a.652.652 0 00-.303-.632zM4.664 5.928a.658.658 0 00-.704 0 .673.673 0 00-.312.632v5.528c.031.344.32.6.663.6a.661.661 0 00.664-.6V6.56a.674.674 0 00-.31-.632zm7.407 2.904a.67.67 0 00-.71 0 .645.645 0 00-.305.632v2.624c.032.344.32.6.664.6a.674.674 0 00.664-.6V9.464a.667.667 0 00-.313-.632z","fill":"#99A5AE"}})])
          )
        }
      }
    